<template>
  <div class="container">
    <div class="ui grid stackable">
      <div class="twelve wide column">
        <h1>Companies Listing</h1>
      </div>

      <listing-buttons :name="btnName" :route="route"></listing-buttons>
    </div>

    <div class="ui divider"></div>

    <div id="table">
      <div class="filter-bar ui grid">
        <div class="ui two column stackable grid form">
          <div class="column align-middle">
            <div class="ui action input">
              <input
                type="text"
                v-model="search.filterText"
                class
                @keyup.enter="doFilter"
                placeholder="Search for machines, assemblies, etc....."
              />
              <div class="ui selection dropdown">
                <input
                  type="hidden"
                  name="navigationItem"
                  id="navigationItem"
                  v-model="search.filters"
                  @change="onChange"
                />
                <div class="default text">Select Filter</div>
                <i class="dropdown icon"></i>
                <div class="menu">
                  <div class="item" data-value="">
                    All
                  </div>
                  <div class="item" data-value="name">
                    Company Name
                  </div>
                  <div class="item" data-value="code">
                    Company Id
                  </div>
                </div>
              </div>
              <div class="ui button" @click="doFilter">Search</div>
            </div>
          </div>
          <div class="column align-middle">
            <div class="ui checkbox">
              <input
                type="checkbox"
                name="inactive"
                v-model="search.inactive"
              />
              <label>Inactive</label>
            </div>
          </div>
        </div>
      </div>
      <vuetable
        ref="vuetable"
        :fields="fields"
        :api-url="apiUrl"
        :data="companies"
        pagination-path
        :per-page="10"
        :multi-sort="true"
        :sort-order="sortOrder"
        :append-params="moreParams"
        @vuetable:pagination-data="onPaginationData"
        :http-options="httpOptions"
      >
        <template slot="actions" slot-scope="props">
          <div class="table-button-container">
            <button class="ui button primary" @click="goToDetail(props)">
              <i class="fa fa-edit"></i>
            </button>
          </div>
        </template>
      </vuetable>

      <vuetable-pagination
        ref="pagination"
        @vuetable-pagination:change-page="onChangePage"
      ></vuetable-pagination>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import APIService from "@/assets/js/APIService";
const apiService = new APIService();
import httpClient from "@/assets/js/HttpClient";

export default {
  Name: "Companies",
  computed: {},
  components: {
    Vuetable,
    VuetablePagination,
  },
  data() {
    return {
      btnName: "Company",
      route: "ManageCompanies",
      showModal: false,
      id: "",
      fields: [
        {
          name: "code",
          title: "Code",
        },
        {
          name: "name",
          title: "Name",
        },
        {
          name: "plant.name",
          title: "Plant Name",
        },
        {
          name: "plant.street",
          title: "Address",
        },
        {
          name: "plant.city",
          title: "City",
        },
        "__slot:actions",
      ],
      search: [
        {
          filterText: "",
          filters: "",
          inactive: true,
        },
      ],
      sortOrder: [
        {
          field: "name",
          sortField: "name",
          direction: "asc",
        },
      ],
      moreParams: {},
      companies: [],
      apiUrl: apiService.getCompanyUrl(),
      httpOptions: {
        headers: httpClient.defaults.headers,
      },
    };
  },
  mounted() {
    $(".ui.dropdown").dropdown({ fullTextSearch: true });
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset(e));

    if(this.$route.query.search != null) {
      this.setSearchParams(this.$route.query.search);
    }
  },
  methods: {
    setSearchParams(filterText) {
      this.search.filterText = filterText;
      this.doFilter();
    },
    getCompanies() {
      apiService.getCompanies().then((data) => {
        this.companies = data;
      });
    },
    goToDetail(company) {
      this.$router.push({
        name: "ManageCompanies",
        params: {
          id: company.rowData.id,
        },
      });
    },
    companySuccessful(request) {
      (this.code = request.code),
        (this.name = request.name),
        (this.plantName = request.plantName),
        (this.address = request.address),
        (this.active = request.active);
    },
    companyFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    doFilter() {
      this.$events.fire("filter-set", this.search);

      if(this.$route.query.search != null) {
        
      this.$set(this.search, this.search.filterText, this.$route.query.search)
        
      } else {
        this.$router.push({path: 'company', query: {search: this.search.filterText}});
      }

      if(this.$route.query.search != this.search.filterText) {
        delete this.$route.query.search;
        this.$router.push({path: 'company', query: {search: this.search.filterText}});
      }
    },
    onChange(event) {
      this.search.filters = event.target.value;
    },
    onFilterSet(data) {
      this.moreParams.filter = data.filters;
      this.moreParams.term = data.filterText;
      this.moreParams.inactive = data.inactive || this.active;
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterReset() {
      delete this.moreParams.filter;
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
  },
  destroyed: function() {
    this.$events.$off("filter-set");
    this.$events.$off("filter-reset");
  },
};
</script>

<style module></style>
